export default "__VITE_ASSET__379d5bf7__"